// extracted by mini-css-extract-plugin
export var menuIcon = "_nm-0";
export var menuIconInline = "_nm-1";